import { RolesWithPermissions } from '../';

export const INSPECTIONS_ROLES: RolesWithPermissions = {
  admin: {
    inspections: {
      view: true,
      create: false,
    },
  },
  general: {
    inspections: {
      view: true,
      create: false,
    },
  },
  supervisor: {
    inspections: {
      view: true,
      create: true,
    },
  },
  backoffice: {
    inspections: {
      view: true,
      create: false,
    },
  },
  client: {
    inspections: {
      view: true,
      create: true,
    },
  },
  agency: {
    inspections: {
      view: true,
      create: false,
    },
  },
  '3rd_inspector': {
    inspections: {
      view: true,
      create: false,
    },
  },
  inspector: {
    inspections: {
      view: true,
      create: false,
    },
  },
};
